import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsCustomersCustomerRoute extends Route {
  @service store;

  model({ customer_id }) {
    return this.store.findRecord('customer', customer_id);
  }
}

export default instrumentRoutePerformance(SettingsCustomersCustomerRoute);
